import { __awaiter } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-80de18e8"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "item--title" };
const _hoisted_2 = { class: "item--date" };
const _hoisted_3 = { class: "item--content" };
const _hoisted_4 = { class: "item--button-box" };
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["onClick"];
import Badge from '@/materials/atoms/Badge.vue';
import MaterialIcon from '@/materials/atoms/MaterialIcon.vue';
import { useMessage } from '@/const/messages';
import { useStore } from '@/store/store';
import { setTimezone } from '@/logics/utils';
export default /*#__PURE__*/ _defineComponent({
    props: {
        notifications: null,
        cursor: null
    },
    emits: ["clickDelete", "clickMore", "clickRead"],
    setup(__props, { emit }) {
        const props = __props;
        const store = useStore();
        const { MYPAGE_MESSAGE, format } = useMessage();
        const onClickRead = (notification) => __awaiter(this, void 0, void 0, function* () { return emit('clickRead', { notification }); });
        const onClickDelete = (notification) => __awaiter(this, void 0, void 0, function* () { return emit('clickDelete', { notification }); });
        const onClickMore = () => __awaiter(this, void 0, void 0, function* () { return !!props.cursor && emit('clickMore'); });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.notifications, (notification) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: notification.id,
                        class: "item"
                    }, [
                        _createElementVNode("div", _hoisted_1, [
                            (!notification.read)
                                ? (_openBlock(), _createBlock(Badge, {
                                    key: 0,
                                    "color-mode": "error",
                                    flash: true,
                                    class: "item--badge"
                                }))
                                : _createCommentVNode("", true),
                            _createElementVNode("p", null, _toDisplayString(_unref(format)(notification.titles)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("span", null, _toDisplayString(_unref(setTimezone)(String(_unref(store).state.userSettings.localTime), notification.created_at, 'YYYY-MM-DD HH:mm:ss')), 1)
                        ]),
                        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(format)(notification.contents)), 1),
                        _createElementVNode("div", _hoisted_4, [
                            (!notification.read)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: "#",
                                    class: "link",
                                    style: { "margin-right": "10px" },
                                    onClick: _withModifiers(($event) => (onClickRead(notification)), ["prevent"])
                                }, [
                                    _createVNode(MaterialIcon, {
                                        name: "check",
                                        class: "icon",
                                        style: { "margin-right": "5px" }
                                    }),
                                    _createTextVNode(" " + _toDisplayString(_unref(format)(_unref(MYPAGE_MESSAGE).LINK_READ)), 1)
                                ], 8, _hoisted_5))
                                : _createCommentVNode("", true),
                            _createElementVNode("a", {
                                href: "#",
                                class: "link --delete",
                                onClick: _withModifiers(($event) => (onClickDelete(notification)), ["prevent"])
                            }, [
                                _createVNode(MaterialIcon, {
                                    name: "delete",
                                    class: "icon",
                                    style: { "margin-right": "5px" }
                                }),
                                _createTextVNode(" " + _toDisplayString(_unref(format)(_unref(MYPAGE_MESSAGE).BTN_DELETE)), 1)
                            ], 8, _hoisted_6)
                        ])
                    ]));
                }), 128)),
                (!!props.cursor)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: "#",
                        class: "link more-link",
                        onClick: _withModifiers(onClickMore, ["prevent"])
                    }, _toDisplayString(_unref(format)(_unref(MYPAGE_MESSAGE).LINK_MORE)), 9, _hoisted_7))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
